const testimonials = [
  {
    id: 1,
    name: 'Dr. Sarah Chen',
    role: 'AI Research Lead',
    company: 'DeepMind',
    content: 'TechInsight provides the most comprehensive and accurate coverage of AI developments. Their deep dives into neural architectures and machine learning algorithms are essential reading for anyone in the field.',
    avatar: 'SC',
    rating: 5
  },
  {
    id: 2,
    name: 'Marcus Rodriguez',
    role: 'Blockchain Architect',
    company: 'Ethereum Foundation',
    content: 'The quality of blockchain analysis here is unmatched. They break down complex DeFi protocols and smart contract architectures in ways that are both accessible and technically rigorous.',
    avatar: 'MR',
    rating: 5
  },
  {
    id: 3,
    name: 'Dr. Priya Patel',
    role: 'Quantum Computing Researcher',
    company: 'IBM Quantum',
    content: 'Finally, a tech publication that understands quantum computing beyond the hype. Their coverage of quantum algorithms and error correction is spot-on and incredibly valuable for researchers.',
    avatar: 'PP',
    rating: 5
  },
  {
    id: 4,
    name: 'James Wilson',
    role: 'CTO',
    company: 'CloudScale Systems',
    content: 'TechInsight keeps our entire engineering team informed about emerging technologies. The articles on edge computing and distributed systems have directly influenced our architecture decisions.',
    avatar: 'JW',
    rating: 5
  },
  {
    id: 5,
    name: 'Elena Kowalski',
    role: 'Security Engineer',
    company: 'CyberShield',
    content: 'The cybersecurity coverage is outstanding. They stay ahead of emerging threats and provide actionable insights that help us protect our infrastructure. A must-read for security professionals.',
    avatar: 'EK',
    rating: 5
  },
  {
    id: 6,
    name: 'David Kim',
    role: 'VP of Engineering',
    company: 'MetaVerse Labs',
    content: 'Their AR/VR and metaverse coverage is exceptional. TechInsight helped us understand the technical foundations needed to build immersive experiences at scale.',
    avatar: 'DK',
    rating: 5
  },
];

export default function Testimonials() {
  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-cyan-500/10 backdrop-blur-sm rounded-full text-cyan-400 mb-6 border border-cyan-500/30">
            <i className="ri-chat-quote-line"></i>
            <span className="text-sm font-semibold">Testimonials</span>
          </div>
          <h2 className="text-4xl font-bold text-white mb-4">Trusted by Tech Leaders</h2>
          <p className="text-gray-400 text-sm">See what industry experts say about our content</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-7 border border-slate-700 hover:border-cyan-500/50 transition-all hover:shadow-lg hover:shadow-cyan-500/20 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-cyan-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-6 flex-grow">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-3 pt-5 border-t border-slate-700">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center text-white font-bold shadow-lg shadow-cyan-500/30">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-semibold text-white text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-400">{testimonial.role} at {testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
